import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import { AXIOS_UPDATE } from "../../server/api/crud";
import Swal from "sweetalert2";
import Dropzone2 from "../Dropzone2";

export default function EditDocument({
  open = false,
  setOpen,
  attachment,
  user,
}) {

  const [progresses, setProgresses] = useState({}); // Track progress for each file
  const [documenten, setDocumenten] = useState([]);
  const [newtitle, setNewtitle] = useState(attachment);

  useEffect(() => {
    setNewtitle(attachment);
  }, [attachment]);

  const reset = () => {
    setProgresses({});
    setDocumenten([]);
    setOpen(false);
  };

  const saveDocuments = async () => {
    let newobject = null;
    if (documenten?.length > 0) {
      let finalDocument = documenten?.map((document) => {
        // Return a new object with updated title, spreading in other properties
        return {
          ...document,
          title: progresses[document?.bestand]?.title, // Fallback to existing title if not in progresses
        };
      });

      newobject = finalDocument[0];
    } else {
      newobject = newtitle;
    }

    const id = newobject?.id;

    await AXIOS_UPDATE("documents", id, { document: newobject })
      .then((result) => {
        if (result.status == 200) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: `Bestands zijn opgeslagen`,
            showConfirmButton: false,
            timer: 2500,
          });

          reset();
        }
      })
      .catch((e) => {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `er is iets mis gelopen`,
          showConfirmButton: false,
          timer: 2500,
        });
      });
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black/70 backdrop-blur-[1px] transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-3 text-center sm:items-center sm:p-4">
          <DialogPanel
            transition
            className="relative w-full transform overflow-hidden rounded-2xl border border-wa-border bg-wa-panel p-4 text-left shadow-2xl shadow-black/40 transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:max-w-4xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="w-full">
              <div className="mb-4 border-b border-wa-border pb-3">
                <h2 className="text-base font-semibold leading-6 text-wa-text sm:text-lg">
                Laad bestanden op
                </h2>
                <p className="mt-1 text-xs text-wa-muted sm:text-sm">
                  Werk een document bij of laad een nieuw bestand op.
                </p>
              </div>
              <div className="rounded-xl border border-wa-border bg-wa-panel2/70 p-3 sm:p-4">
                <Dropzone2
                  user={user}
                  setProgresses={setProgresses}
                  setDocumenten={setDocumenten}
                  updateFile={attachment}
                  setFile={setNewtitle}
                  progresses={progresses}
                />
              </div>
              <div className="mt-4 flex flex-col-reverse gap-2 border-t border-wa-border pt-4 sm:flex-row sm:items-center sm:justify-between">
                <button
                  onClick={() => setOpen(false)}
                  className="inline-flex min-h-[2.5rem] items-center justify-center rounded-lg border border-wa-border bg-wa-panel2 px-4 py-2 text-sm font-semibold text-wa-text transition hover:bg-wa-hover"
                >
                  Sluiten
                </button>
                <button
                  onClick={saveDocuments}
                  className="inline-flex min-h-[2.5rem] items-center justify-center rounded-lg bg-wa-accent px-4 py-2 text-sm font-semibold text-wa-onaccent transition hover:bg-wa-accentdeep"
                >
                  Opslaan
                </button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
